export const NFT_INVENTORY_VALID_UPDATE_REQUEST = 'NFT_INVENTORY_VALID_UPDATE_REQUEST';
